import { render } from "./Routing.vue?vue&type=template&id=5192dbf5"
import script from "./Routing.vue?vue&type=script&lang=js"
export * from "./Routing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__